import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import UserSingleNav from "components/common/user/UserSingleNav/UserSingleNav";
import { UserResult } from "common/user/dto/UserResult";
import { WsNotifyContext } from "common/ws/WsNotify";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { QUERY_KEYS } from "constant/react_query";

type UserReadProps = {
  user: UserResult;
};

const UserRead = ({ user }: UserReadProps) => {
  const wsNotifyContextValue = useContext(WsNotifyContext);
  const invalidateQuery = useInvalidateQueryByKeys();
  useEffect(() => {
    invalidateQuery.invalidateQueriesByKeys([QUERY_KEYS.MATSEND_USER_GET]);
  }, [invalidateQuery, wsNotifyContextValue.notifyTime]);

  return (
    <div>
      <div>{user.un}</div>
      <div>{user.email}</div>
      <DivNav>
        <UserSingleNav user={user} hideReadNav={true} />
      </DivNav>
    </div>
  );
};

const DivNav = styled.div`
  margin-top: 1.5rem;
`;

export default UserRead;
